// src/features/socketSlice.js
import { createSlice } from "@reduxjs/toolkit";
import {SocketState} from "./types";

const initialState:SocketState = {
    messages: [],
    connected: false,
    error: null,
    loading: false,
};

const socketSlice = createSlice({
    name: "socket",
    initialState,
    reducers: {
        socketConnected: (state) => {
            state.connected = true;
            state.error = null;
        },
        socketDisconnected: (state) => {
            state.connected = false;
        },
        socketError: (state, action) => {
            state.error = action.payload;
        },
        receiveMessage: (state, action) => {

            state.messages.push(action.payload);
        },
    },
});

export const {
    socketConnected,
    socketDisconnected,
    socketError,
    receiveMessage,
} = socketSlice.actions;

export default socketSlice.reducer;
